export function mastercardConfigure (instance) {
    return {
        fields: {
            // ATTACH HOSTED FIELDS TO YOUR PAYMENT PAGE FOR A CREDIT CARD
            card: {
                number: '#card-number',
                securityCode: '#security-code',
                expiryMonth: '#expiry-month',
                expiryYear: '#expiry-year'
            }
        },
        // SPECIFY YOUR MITIGATION OPTION HERE
        frameEmbeddingMitigation: ['javascript'],
        callbacks: {
            initialized: function (response) {
                // HANDLE INITIALIZATION RESPONSE
            },
            formSessionUpdate: function (response) {
                // HANDLE RESPONSE FOR UPDATE SESSION
                if (response.status) {
                    if (response.status === 'ok') {
                        instance.processAffirmativeSessionResponse(response)
                    } else if (response.status === 'fields_in_error') {
                        if (response.errors.cardNumber) {
                            instance.processNegativeSessionResponse(response, 'Card number invalid or missing.')
                        } else if (response.errors.expiryYear) {
                            instance.processNegativeSessionResponse(response, 'Expiry year invalid or missing.')
                        } else if (response.errors.expiryMonth) {
                            instance.processNegativeSessionResponse(response, 'Expiry month invalid or missing.')
                        } else if (response.errors.securityCode) {
                            instance.processNegativeSessionResponse(response, 'Security code invalid.')
                        } else if (response.errors.number) {
                            instance.processNegativeSessionResponse(response, 'Gift card number invalid or missing.')
                        } else if (response.errors.pin) {
                            instance.processNegativeSessionResponse(response, 'Pin invalid or missing.')
                        } else if (response.errors.bankAccountHolder) {
                            instance.processNegativeSessionResponse(response, 'Bank account holder invalid.')
                        } else if (response.errors.bankAccountNumber) {
                            instance.processNegativeSessionResponse(response, 'Bank account number invalid.')
                        } else {
                            instance.processNegativeSessionResponse(response, 'Check all card fields are completed correctly.')
                        }
                    } else if (response.status === 'request_timeout') {
                        instance.processNegativeSessionResponse(response, 'Payment update timed out: ' + response.errors.message)
                    } else if (response.status === 'system_error') {
                        instance.processNegativeSessionResponse(response, 'Payment update failed: ' + response.errors.message)
                    }
                } else {
                    instance.processNegativeSessionResponse(response, 'Payment update failed!')
                }
            }
        }
    }
}
